import React from "react";

import css from "./tip.module.scss";

type TipProps = { tip: string };

export const Tip = ({ tip }: TipProps) => (
  <div className={css.tip}>
    <span>{tip}</span>
  </div>
);
